import httpClient from "../axios/interceptors";
import { AuthProfileResponse, ChangePasswordUserSystemInput, ChangePasswordUserSystemResponse, CreateUserSystemInput, CreateUserSystemResponse, DeleteUserSystemInput, DeleteUserSystemResponse, ForgotPasswordInput, ForgotPasswordResponse, InputUpdateFactory, InputUpdateUserProfile, KeepAliveInput, LoginPasswordInput, LoginPasswordResponse, RequestOPTAuthInput, ResendVerifyEmailInput, ResendVerifyEmailResponse, ResetPasswordInput, ResetPasswordResponse, ResponseKeepAlive, ResponseRequestAuthOTP, ResponseSubmitAuthOTP, SetInitialPasswordInput, SetInitialPasswordResponse, SubmitOTPAuthInput, UpdateFactoryResponse, UpdateUserProfileResponse, UpdateUserSystemInput, UserRoleWithoutAdminResponse, UserSystemInput, UserSystemResponse, VerifyRegistrationTokenInput, VerifyRegistrationTokenResponse } from './interface';
import { AxiosResponse } from 'axios'
import { API } from './endpoint';



const handleResponseError = (error: { response: { data: { error: any } } }) => {
  if (error?.response?.data?.error) {
    throw error.response.data.error
  }
  throw error
}



export const requestAuthLogin = async (
  input: SubmitOTPAuthInput
): Promise<ResponseSubmitAuthOTP> => {
  const data: AxiosResponse<ResponseSubmitAuthOTP> = await httpClient
    .post(API.submitAuthOtp, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const requestAuthRequestOtp = async (
  input: RequestOPTAuthInput
): Promise<ResponseRequestAuthOTP> => {
  const data: AxiosResponse<ResponseRequestAuthOTP> = await httpClient
    .post(API.requestAuthOtp, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getAuthProfile = async (): Promise<AuthProfileResponse> => {
  const data: AxiosResponse<AuthProfileResponse> = await httpClient
    .get(API.authProfile)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const requestKeepAlive = async (
  input: KeepAliveInput
): Promise<ResponseKeepAlive> => {
  const data: AxiosResponse<ResponseKeepAlive> = await httpClient
    .post(API.keepAlive, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateFactory = async (
  input: InputUpdateFactory
): Promise<UpdateFactoryResponse> => {
  const data: AxiosResponse<UpdateFactoryResponse> = await httpClient
    .post(API.updateFactory, input)
    .catch((error) => handleResponseError(error))
  return data.data
}



export const updateUserProfile = async (
  input: InputUpdateUserProfile
): Promise<UpdateUserProfileResponse> => {
  const data: AxiosResponse<UpdateUserProfileResponse> = await httpClient
    .post(API.updateUserProfile, input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const getUserRoleWithoutAdmin = async (): Promise<UserRoleWithoutAdminResponse> => {
  const data: AxiosResponse<UserRoleWithoutAdminResponse> = await httpClient
    .get(API.getUserRoleWithoutAdmin)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getUserSystem = async (
  input: UserSystemInput
): Promise<UserSystemResponse> => {
  const data: AxiosResponse<UserSystemResponse> = await httpClient
    .post(API.getUserSystem, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const createUserSystem = async (
  input: CreateUserSystemInput
): Promise<CreateUserSystemResponse> => {
  const data: AxiosResponse<CreateUserSystemResponse> = await httpClient
    .post(API.createUserSystem, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteUserSystem = async (
  input: DeleteUserSystemInput
): Promise<DeleteUserSystemResponse> => {
  const data: AxiosResponse<DeleteUserSystemResponse> = await httpClient
    .post(API.deleteUserSystem , input)
    .catch((error) => handleResponseError(error))
  return data.data
}


export const updateUserSystem = async (
  input: UpdateUserSystemInput
): Promise<CreateUserSystemResponse> => {
  const data: AxiosResponse<CreateUserSystemResponse> = await httpClient
    .post(API.updateUserSystem, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const requestAuthLoginPassword = async (
  input: LoginPasswordInput
): Promise<LoginPasswordResponse> => {
  const data: AxiosResponse<LoginPasswordResponse> = await httpClient
    .post(API.authLoginPassword, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const changePasswordUserSystem = async (
  input: ChangePasswordUserSystemInput
): Promise<ChangePasswordUserSystemResponse> => {
  const data: AxiosResponse<ChangePasswordUserSystemResponse> = await httpClient
    .post(API.changePasswordUserSystem, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const forgotPassword = async (
  input: ForgotPasswordInput
): Promise<ForgotPasswordResponse> => {
  const data: AxiosResponse<ForgotPasswordResponse> = await httpClient
    .post(API.forgotPassword, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const resetPassword = async (
  input: ResetPasswordInput
): Promise<ResetPasswordResponse> => {
  const data: AxiosResponse<ResetPasswordResponse> = await httpClient
    .post(API.resetPassword, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const verifyRegistrationToken = async (
  input: VerifyRegistrationTokenInput
): Promise<VerifyRegistrationTokenResponse> => {
  const data: AxiosResponse<VerifyRegistrationTokenResponse> = await httpClient
    .post(API.verifyRegistrationToken, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const setInitialPassword = async (
  input: SetInitialPasswordInput
): Promise<SetInitialPasswordResponse> => {
  const data: AxiosResponse<SetInitialPasswordResponse> = await httpClient
    .post(API.setInitialPassword, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const resendVerifyEmail = async (
  input: ResendVerifyEmailInput
): Promise<ResendVerifyEmailResponse> => {
  const data: AxiosResponse<ResendVerifyEmailResponse> = await httpClient
    .post(API.resendVerifyEmail, input)
    .catch((error) => handleResponseError(error))
  return data.data
}